import {Help} from "../help.js";
import {Utility} from "../utility.js";

export class Level extends Phaser.Scene {
    static CAMERA_ZOOM = .4
    constructor(key, level, options) {
        if (new.target === Level) throw new TypeError("Cannot construct [Level] instances directly")
        super({key: key})
        this._level = level
        this._elapsed = 0
        this._layout = { }
        this._bob = null
        this._bobDirection = null
        this._cursor = null
        this._options = options
        this._animation = {last: this._options.bobInRed ? "left-red" : "left"}
        this._board = {panel: null, score: null, time: null}
        this._bubble = {container: null, started: null}
        this._peipei = null
        this._peiPeibubble = {container: null, started: null, duration: 0}
        this._spaceKey = null
        this._escKey = null
        this._pickables = null
        this._holder = {
            item: null,
            busy: false,
            take: (item) => {
                if (this._holder.busy) return this._holder
                this._holder.busy = true
                this._holder.item = this.add.image(0,0, `${item.texture.key}`).setDepth(250).setScale(1.5).setVisible(false)
                this._holder.panel.setVisible(true)
                    .play("holder-anim")
                    .once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                        item.destroy()
                        this._holder.item.setVisible(true)
                        this._holder.item.width > 160 && this._holder.item.setScale(0.7)
                        this.sound.play("grabbed-object")
                        const held = this._pickables.list.filter(d => d.name === item.texture.key)
                        held[0].peipei && this.peiPeiSay(held[0].peipei.take)
                        this._holder.busy = false
                    })
                return this._holder
            },
            back: () => {
                if (this._holder.busy || !this._holder.holding()) return this._holder
                const key = this._holder.item.texture.key
                const held = this._pickables.list.filter(d => d.name === key)
                this._holder.empty()
                this._pickables.group.create(held[0].position.left, held[0].position.top, key).setOrigin(0, 0).refreshBody().setDepth(60)
                return this._holder
            },
            drop: (position) => {
                if (this._holder.busy || !this._holder.holding()) return this._holder
                const key = this._holder.item.texture.key
                const held = this._pickables.list.filter(d => key === d.name)
                this._holder.empty()
                this.physics.add.staticImage(position.x, position.y, key).setOrigin(0, 0).refreshBody().setDepth(60)
                held[0].peipei && this.peiPeiSay(held[0].peipei.drop)
                return this._holder
            },
            empty: () => {
                if (this._holder.busy || !this._holder.holding()) return this._holder
                this._holder.panel.setVisible(false)
                this._holder.item.destroy()
                this._holder.item = null
                return this._holder
            },
            holding: () => this._holder.item !== null
        }
        this._scale = {x: 1, y: 1, camera: { x: 1, y: 1} }
        this._GAME_ACTION_POINT = 5
    }
    preload() {
        this.load.spritesheet("bob", "assets/bob.png", {
            frameWidth: 110,
            frameHeight: 165
        });
        this.load.spritesheet("bob-in-red", "assets/bob-in-red.png", {
            frameWidth: 104,
            frameHeight: 142
        });
        this.load.image(this._options.background, this._options.background)
        this.load.image("game-scoreboard", "assets/game-scoreboard.png");
        this.load.image("game-timeout", "assets/game-timeout.png");
        this.load.image("level-completed-panel", "assets/level-completed-panel.png");
        this.load.image("level-completed-star", "assets/level-completed-star.png");
        this.load.image("pei-pei-neutral-logo", "assets/pei-pei-neutral-logo.png");
        this.load.image("pei-pei-name-tag", "assets/pei-pei-name-tag.png");
        this.load.spritesheet("holder-sprite", "assets/holder-sprite.png", {
            frameWidth: 365,
            frameHeight: 369
        });
        this.load.spritesheet("level-completed-sprite", "assets/level-completed-panel.png", {
            frameWidth: 958,
            frameHeight: 974
        });
        this.load.spritesheet("peipei-sprite", "assets/peipei-sprite.png", {
            frameWidth: 183,
            frameHeight: 183
        });
        this.load.image("help-icon","assets/help-icon.png")
        this.load.image("help-arrows","assets/help-arrows.png")
        this.load.image("help-space-bar","assets/help-space-bar.png")
        this.load.image("help-p","assets/help-p.png")
        this.load.image("help-esc","assets/help-esc.png")
        
        //region sounds
        this._options.music && this.load.audio({ key: this._options.music, url: [`assets/sounds/${this._options.music}.mp3`] })
        this.load.audio({
            key: 'peipeiTalks',
            url: [ 'assets/sounds/peipei-talks.wav' ]
        })
        this.load.audio({
            key: 'levelCompleted',
            url: [ 'assets/sounds/level-completed.wav' ]
        })
        this.load.audio({
            key: 'grabbed-object',
            url: [ 'assets/sounds/bob-object-appearance.wav' ]
        })
        this.load.audio({
            key: 'wrong',
            url: [ 'assets/sounds/wrong.mp3' ]
        })
        this.load.audio({
            key: 'right',
            url: [ 'assets/sounds/right.mp3' ]
        })
        this.load.audio({
            key: 'find-object',
            url: [ 'assets/sounds/find-object.mp3' ]
        })
        this.load.audio({
            key: 'speech',
            url: [ 'assets/sounds/speech.mp3' ]
        })
        //endregion
   }
    create() {
        const background = this.physics.add.staticImage(0, 0, this._options.background).setOrigin(0).setScrollFactor(1).refreshBody();
        if ( this._options.fullscreen ) {
            this._scale.x = this.game.canvas.width / background.width / Level.CAMERA_ZOOM;
            this._scale.y = this.game.canvas.height / background.height / Level.CAMERA_ZOOM;
            this._scale.camera.x = this.game.canvas.width / background.width
            this._scale.camera.y = this.game.canvas.height / background.height
        }
        //region Setup World
        this._cursor = this.input.keyboard.createCursorKeys();
        this._bob = this.physics.add.sprite(this._options.x * this._scale.x, this._options.y * this._scale.y, "bob").setCollideWorldBounds(true)
            .setScale(this._scale.x, this._scale.y).setDepth(210);
        this.physics.world.setBounds(0, 0, background.width * this._scale.x, background.height * this._scale.y);
        this.cameras.main.setBounds(0, 0, background.width * this._scale.camera.x, background.height * this._scale.camera.y);
        this.cameras.main.setBounds(0, 0, background.width * this._scale.x, background.height * this._scale.y);
        this.cameras.main.startFollow(this.bob, true, 0.09, 0.09);
        this.cameras.main.setZoom(Level.CAMERA_ZOOM);
        this.playBackground()
        //endregion
        //region Setup Animations
        this.anims.create({
            key: "left",
            frames: this.anims.generateFrameNumbers("bob", { start: 0, end: 3 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "right",
            frames: this.anims.generateFrameNumbers("bob", {start: 5, end: 8}),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "turn-right",
            frames: [{key: "bob", frame: 41}],
            frameRate: 20,
        })
        this.anims.create({
            key: "turn-left",
            frames: [{key: "bob", frame: 4}],
            frameRate: 20,
        })
        this.anims.create({
            key: "left-red",
            frames: this.anims.generateFrameNumbers("bob-in-red", { start: 0, end: 3 }),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "right-red",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 6, end: 9}),
            frameRate: 10,
            repeat:-1
        })
        this.anims.create({
            key: "turn-right-red",
            frames: [{key: "bob-in-red", frame: 5}],
            frameRate: 20,
        })
        this.anims.create({
            key: "turn-left-red",
            frames: [{key: "bob-in-red", frame: 4}],
            frameRate: 20,
        })
        this.anims.create({
            key: "left-with-object",
            frames: this.anims.generateFrameNumbers("bob", {start: 27, end: 30}),
            frameRate: 10,
            repeat: 20
        })
        this.anims.create({
            key: "right-with-object",
            frames: this.anims.generateFrameNumbers("bob", {start: 32, end: 35}),
            frameRate: 10,
            repeat: 20
        })
        this.anims.create({
            key: "turn-right-with-object",
            frames: [{key: "bob", frame: 42}],
            frameRate: 20,
        })
        this.anims.create({
            key: "turn-left-with-object",
            frames: [{key: "bob", frame: 31}],
            frameRate: 20,
        })
        this.anims.create({
            key: "left-red-with-object-red",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 22, end: 25}),
            frameRate: 10,
            repeat: 20
        })
        this.anims.create({
            key: "right-red-with-object-red",
            frames: this.anims.generateFrameNumbers("bob-in-red", {start: 28, end: 31}),
            frameRate: 10,
            repeat: 20
        })
        this.anims.create({
            key: "turn-right-red-with-object-red",
            frames: [{key: "bob-in-red", frame: 27}],
            frameRate: 20,
        })
        this.anims.create({
            key: "turn-left-red-with-object-red",
            frames: [{key: "bob-in-red", frame: 26}],
            frameRate: 20,
        })
        //endregion

        this.anims.create({
            key: "holder-anim",
            frames: this.anims.generateFrameNumbers("holder-sprite", {start: 0, end: 12}),
            frameRate: 20,
            repeat: 0
        })
        
        //region Setup Game
        this._board.panel = this.add.container(0, 0).setDepth(220).setScale(1.5)
        this._board.panel.add(this.physics.add.staticImage(0, 0, "game-scoreboard").setOrigin(0,0))
        this._board.panel.add(this.physics.add.staticImage(230, 0, "game-timeout").setOrigin(0,0))
        this._board.score = this.add.text(95, 28, "0", {
            fontSize: "30px",
            fill: "#000000",
            stroke: "#000000",
            strokeThickness: 1,
            fontFamily: "museo-sans-rounded, sans-serif",
        })
        this._board.time = this.add.text(325, 28, "0", {
            fontSize: "30px",
            fill: "#000000",
            stroke: "#000000",
            strokeThickness: 1,
            fontFamily: "museo-sans-rounded, sans-serif",
        })
        this._board.panel.add([this._board.score, this._board.time])
        //endregion
        //region Pei Pei
        this.anims.create({
            key: "peipei-anim-to-talking",
            frames: this.anims.generateFrameNumbers("peipei-sprite", { start: 0, end: 7 }),
            frameRate: 10,
            repeat: 0
        })
        this.anims.create({
            key: "peipei-anim-to-default",
            frames: this.anims.generateFrameNumbers("peipei-sprite", { start: 9, end: 13 }),
            frameRate: 10,
            repeat: 0
        })
        this._peipei = this.add.sprite(0,0, "peipei-sprite").setOrigin(0,0).setDepth(220).setScale(1.5).setAlpha(0);
        //endregion
        this._spaceKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
        this._escKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ESC);
        this._pKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.P);
        
        if (this._options.holder) this._holder.panel = this.add.sprite(0, 0, "holder-sprite").setDepth(250).setScale(1.5).setVisible(false)

        //help popup region
        this._helpPopup = this.add.image(0,0, "help-icon").setOrigin(0,0).setDepth(220).setScale(1.5).setAlpha(1);
        this._helpPopup.setInteractive()
        this._helpPopup.on('pointerdown', () => this.help());
        //end region
    }
    update(time, delta) {
        this.updateBubble()
        this.updatePeiPeiBubble()

        if (!this.bob) return
        this.bob.setVelocity(0)
        const bobSpeed = this._options.speed ?? 1
        let directions = {
            left: {velocity: {x: -400 * this._scale.x * bobSpeed, y: 0}, animation: this._options.bobInRed ? "left-red" : "left"},
            right: {velocity: {x: 400 * this._scale.x * bobSpeed, y: 0}, animation: this._options.bobInRed ? "right-red" : "right"},
            up: {velocity: {x: 0, y: -400 * this._scale.y * bobSpeed}, animation: this._animation.last},
            down: {velocity: {x: 0, y: 400 * this._scale.y * bobSpeed}, animation: this._animation.last},
            rest: {velocity: {x: 0, y: 0}, animation: (this._animation.last === "left") ? "turn-left" : (this._animation.last === "left-red") ? "turn-left-red" : (this._animation.last === "right-red") ? "turn-right-red" : "turn-right"},
        }
        let d = this.cursor.left.isDown ? directions.left :
            this.cursor.right.isDown ? directions.right :
            this.cursor.up.isDown ? directions.up :
            this.cursor.down.isDown ? directions.down : directions.rest
        this.bob.setVelocity(d.velocity.x, d.velocity.y)
        if (d !== directions.rest) this._animation.last = d.animation
        this._bobDirection = d
        this.play(d)

        this._board.panel.x = this.cameras.main.worldView.right - 750
        this._board.panel.y = this.cameras.main.worldView.y + 75
        this.updateTime(delta)
        this.updateHolder()

        Phaser.Input.Keyboard.JustDown(this._spaceKey) && this.onSpace()
        if (Phaser.Input.Keyboard.JustDown(this._escKey)) {
            Utility.make.dialog.confirmation(this, {
                title: "Back to Home Menu",
                message: "Are you sure you want to leave this level? You will lose your stars",
                scale: 1 / Level.CAMERA_ZOOM,
                proceed: () => {this._level.home()}
            })
        }
        this._helpPopup.x = this.cameras.main.worldView.right - 200
        this._helpPopup.y = this.cameras.main.worldView.bottom - this._helpPopup.height - 150
    }
    onSpace(){
        //NOOP
    }
    get layout() {
        return this._layout
    }
    get bob() {
        return this._bob
    }
    get cursor() {
        return this._cursor
    }
    get board() {
        return this._board
    }
    play(direction) {
        const animation = this._options.bobInRed ? `${direction.animation}-with-object-red` : `${direction.animation}-with-object`
        direction = (this._holder.holding()) ? {...direction, animation: animation} : direction;
        this.bob.anims.play(direction.animation, true)
    }
    updateTime(delta) {
        this._elapsed += delta
        let s = Math.floor(this._elapsed / 1000)
        if (s > 540) return
        let minutes = Math.floor(s / 60)
        let partInSeconds = s % 60
        partInSeconds = partInSeconds.toString().padStart(2, '0')
        this._board.time.setText(`${minutes}:${partInSeconds}`)
    }
    say(msg, x, y) {
        let text = this.add.text(30, 15, msg, {
            fontSize: "40px",
            fill: "#FFFFFF",
            stroke: "#FFFFFF",
            strokeThickness: 1,
            fontFamily: "museo-sans-rounded, sans-serif",
        })
        let w = text.width + 60
        let panel = this.add.graphics()
            .fillStyle(0x070b34, 1)
            .fillRoundedRect(0, 0, w, 80, 20)
        if (this._bubble.container) this._bubble.container.destroy()
        this._bubble.container = this.add.container(x,y).setDepth(200).setVisible(false)
        this._bubble.container.width = w
        this._bubble.container.height = 80
        this._bubble.container.add([panel, text])
        this._bubble.started = Date.now()
    }
    updateBubble(){
        let b = this._bubble
        if (!b.container || !this.bob) return
        b.container.setVisible(true)
        b.container.x = this.bob.body.center.x - b.container.width / 2
        b.container.y = this.bob.y - 175
        if (Date.now() - b.started > 2000) {
            b.container.destroy()
            b.container = null
        }
    }
    win(score){
        this.sound.play("levelCompleted")
        this.anims.create({
            key: "level-completed-anim",
            frames: this.anims.generateFrameNumbers("level-completed-sprite", { start: 0, end: 15 }),
            frameRate: 10,
            repeat: 0
        })
        this._level.win()
        let center = {
            x: this.cameras.main.worldView.centerX,
            y: this.cameras.main.worldView.centerY
        }
        let board = this.add.container(center.x, center.y).setScale(1.5).setDepth(230);
        board.add(this.physics.add.sprite(0,0,"level-completed-sprite").play("level-completed-anim"));
        let home = Utility.make.button("HOME", {scene: this, x: -124, y: 171, color: 0xFFA500, hover: 0xcf202f}).setVisible(false)
        let next = Utility.make.button("NEXT", {scene: this, x: 136, y: 171, color: 0xFFA500, hover: 0xcf202f}).setVisible(false)
        setTimeout(() => {
            board.add(Utility.make.text(this, -90, 63, `${score.substring(0, this.board.score.text.indexOf('/'))} stars earned!`, {fontSize: `35px`}).setResolution(1))
            board.add(this.physics.add.staticImage(-124,84, "level-completed-star"));
            board.add([home.setVisible(true), next.setVisible(true)])
        }, 1500);
        home.on('pointerdown', ()=> {this._level.home()})
        next.on('pointerdown', ()=> {this._level.play.next()})
        this.bob.destroy()
        this._bob = null
    }
    peiPeiSay(msg){
        if (!msg) return
        if (this._peiPeibubble.container) this._peiPeibubble.container.destroy()
        this.sound.play("peipeiTalks")
        this._peipei.play("peipei-anim-to-talking").once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            this._peiPeibubble.container = this.add.container(0, 0).setDepth(220).setVisible(false)
            let nameTag = this.add.image(100,0, "pei-pei-name-tag")
            let text = Utility.make.text(this, 30, 30, msg, {
                fontSize: `50px`,
                align: "center",
                wordWrap: { width: 400, useAdvancedWrap: true }
            }).setResolution(1)
            let w = text.width + 60
            let h = text.height + 60
            let panel = this.add.graphics().fillStyle(0x070b34, 1).fillRoundedRect(0, 0, w, h, 20)
            let point1X = Math.floor(w / 7)
            let point1Y = h
            let point2X = Math.floor((w / 7) * 1.7)
            let point2Y = h
            let point3X = Math.floor(w / 7)
            let point3Y = Math.floor(h + h/7)
            panel.fillTriangle(point1X, point1Y, point2X, point2Y, point3X, point3Y)
            this._peiPeibubble.container.width = w
            this._peiPeibubble.container.height = h
            this._peiPeibubble.container.add([panel, text, nameTag])
            this._peiPeibubble.started = Date.now()
            this._peiPeibubble.duration = Math.max(msg.length * 225, 12000)
        })
    }
    updatePeiPeiBubble(){
        this._peipei.setAlpha(1)
        this._peipei.x = this.cameras.main.worldView.x + 120;
        this._peipei.y = this.cameras.main.worldView.bottom - this._peipei.height - 185;
        let b = this._peiPeibubble
        if (!b.container) return
        b.container.setVisible(true)
        b.container.x = this.cameras.main.worldView.x + 100
        b.container.y = this.cameras.main.worldView.bottom - this._peipei.height - 250 - this._peiPeibubble.container.height
        if (Date.now() - b.started > this._peiPeibubble.duration) {
            b.container.destroy()
            b.container = null
            this._peipei.play("peipei-anim-to-default")
        }
    }
    updateHolder() {
        if (!this._options.holder) return false
        this._holder.offset = {
            x: this.cameras.main.worldView.x,
            y: this.cameras.main.worldView.y
        }
        this._holder.panel.x = this._holder.offset.x + 300
        this._holder.panel.y = this._holder.offset.y + 300
        if (!this._holder.holding()) return
        this._holder.item.x = this._holder.panel.x
        this._holder.item.y = this._holder.panel.y
        return true
    }
    help() {
        this.scene.pause()
        const h = new Help({
            description: this.constructor.info.description,
            home: () => {
                this.scene.remove(h.scene.key)
                this._level.home()
            },
            cancel: () => this.scene.remove(h.scene.key).resume()
        })
        this.scene.add("help", h, true)
    }
    playBackground() {
        if (!this._options.music) return
        this.game.sound.stopAll()
        this._music = this.sound.add(this._options.music, { mute: false, volume: 0.2, rate: 1, detune: 0, seek: 0, loop: true, delay: 0 });
        this._music.play()
    }
    debug(msg) {
        console.log(`[${this.constructor.name}] ${msg}`);
    }
}